import { useEffect, useState } from "react";

import Typography from "@material-ui/core/Typography";

const dateOptions = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
};

function getDateString() {
  return new Date().toLocaleDateString("en-US", dateOptions);
}

function Clock() {
  const [date, setDate] = useState(() => getDateString());

  useEffect(() => {
    let isSubscribed = true;

    let rAFId;
    const rAFCallback = () => {
      if (isSubscribed === true) {
        setDate(getDateString());
      }

      rAFId = window.requestAnimationFrame(rAFCallback);
    };
    rAFId = window.requestAnimationFrame(rAFCallback);

    return function cleanup() {
      isSubscribed = false;
      window.cancelAnimationFrame(rAFId);
    };
  }, [date]);

  return (
    <Typography variant="body2" gutterBottom>
      {`Today is ${date}`}
    </Typography>
  );
}

export default Clock;
